import React, { useMemo } from 'react';

import { observer } from 'mobx-react-lite';

import { FavoriteBets } from '../favoriteBets';
import { ReBet } from '../autoBet';
import { Statistic } from '../statistics';
import { BET_ACTION_MODAL_TYPE } from '../../enums/betActionModal';

const GameTop = observer(({ children }) => {

  return (
    <div className="roulette-game-top">
      {children}
    </div>
  );
});
export default GameTop;
